import { validatePhoneNumberLength } from 'libphonenumber-js'

export function validPhone(event, country_prefix) {
  // If press backspace
  if (event.data == null) {
    return true
  }

  if (event.data == '+') {
    event.preventDefault()
  }

  // Test a number
  if (!/^[+0-9]+$/.test(event.data)) {
    event.preventDefault()
  }

  // Valid max length number phone
  const validate = validatePhoneNumberLength(event.target.value + event.data, country_prefix)
  if (validate === 'INVALID_LENGTH') event.preventDefault()
  if (validate === 'TOO_LONG') event.preventDefault()
}
